module.exports = __webpack_public_path__ + "img/yhpc.3b31b4ce.svg";